/* ------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <section aria-labelledby="signInForm">
    <div
      v-if="hasKey"
      class="row"
      style="text-align: center"
    >
      <h1 id="signInForm">
        Signing In ...
      </h1>
    </div>
    <div
      v-if="!hasKey"
      class="row"
    >
      <div
        v-if="isIe"
        class="container-fluid"
      >
        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <div class="alert alert-danger">
              <strong>ATTENTION<br></strong>
              <span role="alert">
                You appear to be using Internet Explorer.<br><br>
                This browser does not support all the audio features needed for a full experience.
                As a result, some features on the site may not work properly.
                Please use Microsoft Edge, Chrome or Firefox instead.
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-sm-offset-3">
        <div class="row">
          <div class="col-sm-6">
            <h1 id="signInForm">
              Sign In
            </h1>
          </div>
          <nav
            class="col-sm-6 text-right"
            aria-label="page navigation"
          >
            <span>
              <br>
              Not registered?
              <router-link :to="{ name: 'sign-up' }">
                Create an Account
              </router-link>
            </span>
          </nav>
        </div>
        <form
          aria-label="Sign In Form"
          @submit.prevent="signIn"
        >
          <div class="form-group">
            <label for="signInEmail">
              Email address
            </label>
            <input
              id="signInEmail"
              v-model.trim="formValues.email"
              type="email"
              class="form-control"
              placeholder="email"
              name="email"
              required
            >
          </div>
          <div class="form-group">
            <label for="signInPassword">
              Password
            </label>
            <input
              id="signInPassword"
              v-model.trim="formValues.password"
              type="password"
              class="form-control"
              placeholder="password"
              required
            >
          </div>
          <div>
            <router-link
              :to="{ name: 'password-forgot', query: { email: formValues.email } }"
            >
              Forgot password?
            </router-link>
          </div>
          <div class="help-block">
            <p
              v-if="errors.display"
              class="text-danger"
              role="alert"
            >
              {{ errors.message }}
            </p>
          </div>
          <br>
          <loading-button :loading="signingIn">
            Sign in
          </loading-button>
          <span class="btcSignIn">
            [
            <a
              href="#"
              @click.prevent="sendToBtcHub"
            >
              Sign In with Bigtincan Hub
            </a>
            ]
          </span>
        </form>
      </div>
    </div>
  </section>
</template>

<style type="less" scoped>
  .btcSignIn {
    margin-left: 40px;
    color: #F26724;
  }
</style>

<script>
import BtcMixin from '../specials/BtcMixin';

export default {
  mixins: [BtcMixin],
  data() {
    return {
      signingIn: false,
      errors: {
        message: 'Incorrect credentials',
        display: false
      },
      formValues: {
        email: this.$route.query.email,
        password: ''
      }
    };
  },
  computed: {
    preferences() {
      return this.$store.getters.preferences;
    },
    hasKey() {
      return this.$route.query && this.$route.query.key;
    },
    isIe() {
      return (navigator.appName == 'Microsoft Internet Explorer' || !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g));
    }
  },
  created() {
    this.$store.dispatch('resetGroupMembersCache');

    if (this.$route.query.key) {
      this.$store.dispatch('autoSignIn', this.$route.query.key).then(() => {
        if (this.$route.query.next) {
          return this.$router.push(this.$route.query.next);
        }
        // Send them to confirm-code to leverage the behavior there that
        // will redirect them to the correct homepage
        this.$router.push({name: 'confirm-code'});
      });
    }
  },
  methods: {
    signIn() {
      this.$store.dispatch('resetGroupMembersCache');

      let next = this.$route.query.next || 'confirm-code'; // use confirm-code as a bounce page
      if (this.$route.query && this.$route.query.code) {
        next = {name: 'confirm-code', query: {code: this.$route.query.code}};
      }

      this.signingIn = true;
      this.$store.dispatch('signIn', this.formValues)
        .then(() => {
          this.$router.push(next);
        })
        .catch(errors => {
          if (errors[0].$status === 401) {
            this.$announcer.set(errors[0].message);
            this.errors.message = errors[0].message;
            this.errors.display = true;
          }
        })
        .finally(() => {
          this.signingIn = false;
        });
    }
  }
};
</script>
